import { Team } from './team';

export type HomeAndAway = {
  home: string;
  away: string;
};

export type Match = {
  id: string;
  isInternal: boolean;
  externalId?: string;
  currentMinute?: string;
  // 2024-03-29
  date: string;
  // 15:00:00
  time?: string;
  attendance: number;
  status: MatchStatus;
  stadium?: string;
  score: {
    current: {
      away: number;
      home: number;
    };
    halfTime?: {
      away: number;
      home: number;
    };
    penalties?: {
      away: number;
      home: number;
    };
  };
  goals?: {
    home: Goal[];
    away: Goal[];
  };
  competition: {
    id: string;
    name: string;
    slug?: string;
  };
  round?: {
    id: string;
    name: string;
  };
  subs?: {
    home: PlayerLineup[];
    away: PlayerLineup[];
  };
  lineups?: {
    home: PlayerLineup[];
    away: PlayerLineup[];
  };
  homeTeam: Omit<Team, 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt' | 'teams' | 'gender' | 'club'> & {
    club?: Omit<Team['club'], 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt'>;
  };
  awayTeam: Omit<Team, 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt' | 'teams' | 'gender' | 'club'> & {
    club?: Omit<Team['club'], 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt'>;
  };
  info?: string;

  liveCommentaryHome?: string;
  liveCommentaryAway?: string;
  liveStreamPreGameHome?: string;
  liveStreamPreGameAway?: string;
  liveStreamHome?: string;
  liveStreamAway?: string;
  matchProgrammeHome?: string;
  matchProgrammeAway?: string;
  matchHighlightsHome?: string;
  matchHighlightsAway?: string;
  podcastHome?: string;
  podcastAway?: string;
  ticketsHome?: string;
  ticketsAway?: string;
  recommendedHotel?: string;
  preGameInterviewHome?: string;
  preGameInterviewAway?: string;
};

export enum MatchPeriodFilter {
  Days = 'Days',
  Weeks = 'Weeks',
  Months = 'Months',
  Custom = 'Custom',
}

export enum MatchSort {
  ASC = 'asc',
  DESC = 'desc',
}

export enum MatchStatus {
  Abandoned = 'Abandoned',
  Postponed = 'Postponed',
  NotKickedOff = 'NotKickedOff',
  FirstHalf = 'FirstHalf',
  HalfTime = 'HalfTime',
  SecondHalf = 'SecondHalf',
  FullTime = 'FullTime',
  FirstHalfOfExtraTime = 'FirstHalfOfExtraTime',
  HalfTimeInExtraTime = 'HalfTimeInExtraTime',
  SecondHalfOfExtraTime = 'SecondHalfOfExtraTime',
  FullTimeAfterExtraTime = 'FullTimeAfterExtraTime',
  PenaltyShootOut = 'PenaltyShootOut',

  // Streamline-specific statuses
  Live = 'Live',
}

type Player = {
  id: string;
  firstName: string;
  lastName: string;
};

type Goal = {
  player: Player;
  minute: number;
  description?: string;
  sort: number;
};

type PlayerLineup = {
  shirtNumber: number;
  sort: number;
  player: Player;
  isCaptain: boolean;
  // In minutes indicating when the card was shown
  yellowCards?: [];
  // In minutes indicating when the card was shown
  redCard?: number;
  replaces?: {
    player: Player;
    minute: number;
    shirt: number;
  };
  replacedBy?: {
    player: Player;
    minute: number;
    shirt: number;
  };
  goals?: Goal[];
};

export enum MatchStatusFilter {
  LIVE = 'live',
  POSTPONED = 'postponed',
  RESULT = 'result',
  FIXTURE = 'fixture',
  ANY = 'any',
}

export type MatchFilterConfig = {
  label: string;
  competitions: string;
};

export type MatchFilter = {
  competition?: string;
  teamId?: string;
  // @deprecated use teamId instead
  club?: string;
  status?: MatchStatusFilter;
  period?: MatchPeriodFilter;
  periodLimit?: number;
  startDate?: string;
  endDate?: string;
  limit?: number;
  page?: number;
  sort?: MatchSort;
};
